import { render } from "./PublicationFeedGroup.vue.js?vue&type=template&id=cd726804!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroup.vue?vue&type=template&id=cd726804"
import script from "./PublicationFeedGroup.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroup.vue?vue&type=script&lang=js"
export * from "./PublicationFeedGroup.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationFeedGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd726804"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd726804', __exports__)) {
    api.reload('cd726804', __exports__)
  }
  
  module.hot.accept("./PublicationFeedGroup.vue.js?vue&type=template&id=cd726804!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroup.vue?vue&type=template&id=cd726804", () => {
    api.rerender('cd726804', render)
  })

}


export default __exports__